import React from 'react';

import { Link, useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import { logout } from '../../actions/auth';

import '../../styles/navTopMenuStyle.scss';

import { validateAccessUser } from '../../constants/component/validateAccessUser';
import * as view from '../../constants/models/viewsList';
import { ADMINISTRADOR, ADMINISTRADOR_ZONA, EMPLEADO, GERENTE, REPRESENTANTE } from '../../constants/models/typeOperationRol';

export const NavTopMenu = () => {

  const dispatch = useDispatch();

  const history = useHistory();

  const { isLoggedIn, user } = useSelector( state => state.auth);
  const operationRol = isLoggedIn? user.operationRol:'---';

  /**
     * Realiza el cierre de sesión y redirección a login
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
  const handleLogout = () => {
    dispatch( logout() )
    .then(()=>{
      console.log('ok logout')
      history.push('/auth/');
      }
    );
  }
    return (
        <>
        <nav className="navbar navbar-expand-sm base-container mt-0 me-0 mb-3">
          <div className="container-fluid p-0">
            <div className="row m-0 p-0 w-100">
              <div className="col-12">
                <div className="d-flex flex-row-reverse">
                <button className="navbar-toggler btn btn-expand-menu" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
                  <i className="fas fa-bars"></i>
                </button>
                  <div className="">
                    <div className="btn-group dropstart">
                      <button className="btn custom-btn-icons" href="/#" type="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="fas fa-cog"></i>
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <li><button type="button" className="btn custom-btn-icons" onClick={handleLogout}>
                      <i className="fas fa-sign-out-alt"></i><span>Cerrar sesión</span>
                    </button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="spacerClientName">
                    <span className="d-block h6 m-0 p-0">{isLoggedIn ? user.name:'---'}</span>
                    <span className="d-block client-number ps-3">Usuario: {isLoggedIn ? user.noCustomer :'---'} | Rol: {isLoggedIn ? (user.operationRol === GERENTE? REPRESENTANTE : user.operationRol) :'---'}</span>
                  </div>

                </div>
              </div>
              <div className="collapse d-sm-none" id="navbarToggleExternalContent">
                <ul className="nav nav-pills flex-column w-100 mb-sm-auto ps-3 mb-0 align-items-center align-items-sm-start" id="menu">
                    <li className="nav-item w-100 pt-2 ps-3 pb-3 action-link-menu">
                    <Link to='/' className="h6 px-0 custom-text-menu align-middle">
                    <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-home"></i>
                          <span className="ms-1">Inicio</span>
                      </Link>
                    </li>
                    <span className={`
                      ${validateAccessUser(view.VIEW_ZONE_ADMIN ,user) || validateAccessUser(view.VIEW_GROUP ,user) || validateAccessUser(view.CREATE_GROUP ,user) || validateAccessUser(view.VIEW_USER ,user) || validateAccessUser(view.UPDATE_USER, user) || validateAccessUser(view.CREATE_CONTENT, user) || validateAccessUser(view.VIEW_CONTENT, user)
                        ? 'd-inline' : 'd-none'}
                      h5 custom-text-title-menu
                    `}>Administración</span>
                    <li className={`
                      ${(validateAccessUser(view.VIEW_ZONE_ADMIN ,user)) && operationRol === ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                      nav-item w-100 ps-3 pt-2 pb-2 action-link-menu
                    `}>
                        <a href="#submenu1" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-user-friends"></i>
                          <span className="ms-1">Administrador de zona</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenu1" data-bs-parent="#menu">
                          <li className={`
                            ${validateAccessUser(view.VIEW_ZONE_ADMIN ,user) && operationRol === ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/administration/admin-zone' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Ver administrador</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${(validateAccessUser(view.VIEW_GROUP ,user) || validateAccessUser(view.CREATE_GROUP ,user)) && operationRol !== EMPLEADO && operationRol !== ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                      nav-item w-100 ps-3 pt-2 pb-2 action-link-menu
                    `}>
                        <a href="#submenu2" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-user-friends"></i>
                          <span className="ms-1">Grupos</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenu2" data-bs-parent="#menu">
                          <li className={`
                            ${validateAccessUser(view.VIEW_GROUP ,user) && operationRol !== EMPLEADO ? 'd-inline' : 'd-none'}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/administration/groups' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Ver grupos</span>
                            </Link>
                          </li>
                          <li className={`
                            ${validateAccessUser(view.CREATE_GROUP ,user) && operationRol === ADMINISTRADOR ? 'd-inline' : 'd-none'}
                            w-100 action-link-menu pt-2
                          `}>
                            <Link to='/administration/groups/create' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Nuevo grupo</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${(validateAccessUser(view.VIEW_USER ,user) || validateAccessUser(view.UPDATE_USER, user)) && operationRol !== EMPLEADO && operationRol !== ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                      nav-item w-100 ps-3 pt-2 pb-2 action-link-menu
                    `}>
                        <a href="#submenu3" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-users"></i>
                          <span className="ms-1">Representantes</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenu3" data-bs-parent="#menu">
                          <li className="w-100 action-link-menu pb-3 pt-2">
                            <Link to='/administration/users' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Ver representantes</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${validateAccessUser(view.CREATE_CONTENT, user) || validateAccessUser(view.VIEW_CONTENT, user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pt-2 ps-3 pb-2 action-link-menu
                    `}>
                        <a href="#submenuContent" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="far fa-newspaper"></i>
                          <span className="ms-1">Contenidos</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column pb-2 ms-2" id="submenuContent" data-bs-parent="#menu">
                          <li className="w-100 action-link-menu pb-3 pt-2 ">
                            <Link to='/administration/content/marketing' className="px-1 custom-text-menu text-sub-menu">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Avisos</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <span className={`
                      ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM ,user) || validateAccessUser(view.VIEW_PREVIOUS_PROGRAM_DETAIL ,user) || validateAccessUser(view.VIEW_PAYMENT ,user) || validateAccessUser(view.VIEW_PAYMENT_DETAIL ,user) || validateAccessUser(view.VIEW_ADVANCE_PAYMENT ,user) || validateAccessUser(view.VIEW_SALE_ORDER ,user) ? 'd-inline' : 'd-none'}
                      custom-text-title-menu h5
                    `}>Operación</span>

                    <li className={`
                      ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM ,user) || validateAccessUser(view.VIEW_PREVIOUS_PROGRAM_DETAIL ,user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pt-2 ps-3 pb-2 action-link-menu
                    `}>
                      <a href="#submenuPreviousProgram" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-boxes"></i>
                        <span className="ms-1">Programa previo</span>
                        <i className="fas fa-angle-down mt-1 ms-auto"></i>
                      </a>
                      <ul className="collapse nav flex-column ms-2 pb-2" id="submenuPreviousProgram" data-bs-parent="#menu">
                        <li className={`
                          ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM ,user) ? 'd-inline' : 'd-none'}
                          w-100 action-link-menu pb-3 pt-2
                        `}>
                          <Link to='/operation/previous-program' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-inline">Ver programa previo</span>
                          </Link>
                        </li>
                        <li className={`
                          ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM_DETAIL ,user) ? 'd-inline' : 'd-none'}
                          w-100 action-link-menu pt-2
                        `}>
                          <Link to='/operation/detail-previous-program' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-inline">Detalle del programa previo</span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className={`
                      ${validateAccessUser(view.VIEW_PAYMENT ,user) || validateAccessUser(view.VIEW_PAYMENT_DETAIL ,user) || validateAccessUser(view.VIEW_ADVANCE_PAYMENT ,user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pb-2 pt-2 ps-3 action-link-menu
                    `}>
                        <a href="#submenuPayment" data-bs-toggle="collapse" className="custom-text-menu h6 w-100 px-0 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-credit-card"></i>
                          <span className="ms-1">Pagos</span>
                          <i className="fas fa-angle-down ms-auto mt-1"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenuPayment" data-bs-parent="#menu">
                        <li className={`${ (validateAccessUser(view.VIEW_ADVANCE_PAYMENT ,user) && operationRol !== ADMINISTRADOR_ZONA) ? 'd-block' : 'd-none' } w-100 action-link-menu pb-3 pt-2 `}>
                            <Link to='/operation/advance-payment' className="px-1 custom-text-menu text-sub-menu">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Referencia de anticipo</span>
                            </Link>
                          </li>
                          <li className={`
                            ${validateAccessUser(view.VIEW_PAYMENT ,user) ? 'd-inline' : 'd-none'}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/payment' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Pago de facturas</span>
                            </Link>
                          </li>
                          <li className={`
                            ${validateAccessUser(view.VIEW_PAYMENT_DETAIL ,user) ? 'd-inline' : 'd-none'}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/detail-payment' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Pagos procesados</span>
                            </Link>
                          </li>
                          <li className={`
                            ${validateAccessUser(view.VIEW_ANTICIPATION_PAYMENT ,user) ? 'd-inline' : 'd-none'}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/detail-advance-payment' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Pagos de anticipo</span>
                            </Link>
                          </li>
                          <li className={`
                            ${validateAccessUser(view.BILLING_STATEMENT ,user) ? 'd-inline' : 'd-none'}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/billing-statement' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Estados de cuenta</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${validateAccessUser(view.VIEW_SALE_ORDER ,user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/sale-order' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-coins"></i>
                        <span className="ms-1">Órdenes de venta</span>
                      </Link>
                    </li>
                    <li className={`
                      ${validateAccessUser(view.VIEW_DISCOUNT_AND_INVOINCE ,user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/discounts-and-invoices/header' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-tags"></i>
                        <span className="ms-1">Bonificaciones y Descuentos</span>
                      </Link>
                    </li>
                    <li className={`
                      ${validateAccessUser(view.VIEW_MANAGEMENT_ADVANCES_INVOICES ,user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/advance-and-invoices' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fa fa-table"></i>
                        <span className="ms-1">Consulta de anticipos</span>
                      </Link>
                    </li>
                    <li className={`
                      ${validateAccessUser(view.VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS ,user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/advances-invoices-and-complements' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fa fa-table"></i>
                        <span className="ms-1">Consulta de facturas</span>
                      </Link>
                    </li>
                    <span className={`
                      ${validateAccessUser(view.UPDATE_PASS ,user) ? 'd-inline' : 'd-none'}
                      custom-text-title-menu h5
                    `}>Configuración</span>
                    <li className={`
                      ${validateAccessUser(view.UPDATE_PASS ,user) ? 'd-inline' : 'd-none'}
                      nav-item w-100 pt-2 ps-3 pb-2 action-link-menu
                    `}>
                      <a href="#submenuAccount" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-user"></i>
                        <span className="ms-1">Cuenta</span>
                        <i className="fas fa-angle-down mt-1 ms-auto"></i>
                      </a>
                      <ul className="collapse nav flex-column ms-2 pb-2" id="submenuAccount" data-bs-parent="#menu">
                        <li className={`
                          ${validateAccessUser(view.UPDATE_PASS ,user) ? 'd-inline' : 'd-none'}
                          w-100 action-link-menu pb-3 pt-2
                        `}>
                          <Link to='/configuration/account' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-inline">Cambiar contraseña</span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
        </>
    )
}